<template>
 <div class="bannerCom" ref="bgImg" :style="{height:bannerHerght+'px'}">    
    <div  class="bg-img" :style="{height:bannerHerght+'px',width: getBannerWidth}">
        <div  class="wh_bg"  v-for="bannerItem in banners" :key="bannerItem.Fid">
            <img :src="bannerItem.FbgImage" alt="">
        </div>
    </div>
    <section class="wh_content" @touchmove="fn" >
        <div ref="wh_swiper" :class="className" :style="{width: getBannerWidth}" class="wh_swiper" @touchstart="s" @touchmove="m" @touchend="e">
            <div class="bgImg" v-for="bannerItem in banners" :key="bannerItem.Fid" >
                <a :href="bannerItem.Flink">
                    <img :style="{height:imgHeight+'px',left:adLeft+'px'}" :src="bannerItem.Fimage" />
                </a>
            </div>
        </div>
        <div v-if="showIndicator" class="wh_indicator">
            <div v-for="(tag,$index) in slidesLength" v-bind:class="{ wh_show_bgcolor: index-1==$index }" class="wh_indicator_item"></div>
        </div>
    </section>
    <div class="circle"></div>     
 </div>   
</template>

<script>
    export default {      
        name :'XR-sqswiper',
        data() {
            return {
                banners:[],
                slidesLength: 1,
                bgCount:0,
                bannerHerght:document.documentElement.clientWidth*0.5,
                imgHeight:document.documentElement.clientWidth*0.9*0.35,
                adLeft: document.documentElement.clientWidth*0.05/2,
                _width: 0,
                getBannerWidth: 0,
                getImgWidth: 0,
                auto: true,
                slideing: true,
                timer1: '',
                className: '',
                dom: {},        
                t: {
                    sx: 0,
                    s: 0,
                    m: 0,
                    e: 0
                },
                index: 1,
                imgLen: 0,
            }
        },
        props: {
            //滑动所需要的时间
            autoPlay: {
                default: true
            },
            //一次滑动需要走多久
            duration: {
                default: 1000
            },
            //两次滑动间隔的时间
            interval: {
                default: 3500
            },     
            showIndic:Boolean
        },
        computed:{
            showIndicator: function(){
                return typeof(this.showIndic) == "boolean" ? this.showIndic : true
            },
        },
        mounted() {
            this.className = `wh_swiper_${Math.random().toFixed(3) * 1000}`
        },
        methods: {
            setInterval(val){
                this.interval = val
            },
            setBanners(banners){
                this.banners = banners
                this.setWidth()
                setTimeout(() => {
                    //克隆dom
                    this.starDom()
                    this.imgLen = this.banners.length+2
                    for(var i=0;i<this.imgLen;i++){
                        this.dom2[i].style.transform='scale(1)'
                        this.dom2[i].style.transition='250ms'
                    } 
                    this.dom.transform = `translate3d(${this._width * -1}px, 0px, 0px)`
                    this.dom['-webkit-transform'] = `translate3d(${this._width * -1}px, 0px, 0px)`
                    this.dom['-ms-transform'] = `translate3d(${this._width * -1}px, 0px, 0px)`

                    this.dom3.transform = `translate3d(${this._width * -1}px, 0px, 0px)`
                    this.dom3['-webkit-transform'] = `translate3d(${this._width * -1}px, 0px, 0px)`
                    this.dom3['-ms-transform'] = `translate3d(${this._width * -1}px, 0px, 0px)`
                    if (this.autoPlay) {
                        this.setTime()
                    }
                }, 50)
            },
            s(x) {
                if (this.slideing) {
                    for(var i=0;i<this.imgLen;i++){
                        this.dom2[i].style.transform='scale(0.85)'
                        this.dom2[i].style.transition='250ms'
                    }   
                    this.clearTimeOut()
                    this.t.sx = this.getTransform()
                    this.t.s = x.touches[x.touches.length - 1].clientX
                }
            },
            m(x) {
                if (this.slideing && this.t.s != -1) {
                    this.clearTimeOut()
                    this.dom = this.dom
                    this.t.m = x.touches[x.touches.length - 1].clientX - this.t.s
                    this.setTransform(this.t.m + this.t.sx)
                }
            },
            e(x) {
                if (this.slideing && this.t.s != -1) {  
                    for(var i=0;i<this.imgLen;i++){
                        this.dom2[i].style.transform='scale(1)'
                        this.dom2[i].style.transition='250ms'
                    } 
                    this.clearTimeOut()
                    this.setTransform(this.t.m + this.t.sx)
                    var x = this.getTransform()
                    x += this.t.m > 0 ? this._width * 0.3 : this._width * -0.3
                    this.index = Math.round(x / this._width) * -1
                    this.wh('touch')
                }
            },
            setWidth(){
                this.getBannerWidth = (this.banners.length +2) *100 + '%';
                this.getImgWidth = 100/(this.banners.length +2)+'%';
            },
            setTransform(num) {
                for(var i=0;i<this.imgLen;i++){
                    this.dom2[i].style.transform='scale(0.85)'
                    this.dom2[i].style.transition='250ms'
                }
                this.dom.transform = `translate3d(${num}px, 0px, 0px)`
                this.dom['-webkit-transform'] = `translate3d(${num}px, 0px, 0px)`
                this.dom['-ms-transform'] = `translate3d(${num}px, 0px, 0px)`   
                this.dom3.transform = `translate3d(${num}px, 0px, 0px)`
                this.dom3['-webkit-transform'] = `translate3d(${num}px, 0px, 0px)`
                this.dom3['-ms-transform'] = `translate3d(${num}px, 0px, 0px)`           
            },
            getTransform() {
                var x = this.dom.transform || this.dom['-webkit-transform'] || this.dom['-ms-transform'];
                x = x.substring(12)
                x = x.match(/(\S*)px/)[1]
                return Number(x)
            },
            fn(e) {
                e.preventDefault()
            },
            prevSlide() {
                this.clearTimeOut()
                this.index--
                this.wh()
            },
            nextSlide() {
                this.clearTimeOut()
                this.index++
                this.wh()
            },
            slideTo(index) {
                this.clearTimeOut()
                this.index = index + 1
                this.wh()
            },
            wh(type) {
                this.slideing = false
                this.dom.transition = type == 'touch' ? '250ms' : this.duration + 'ms'
                 this.dom3.transition = type == 'touch' ? '250ms' : this.duration + 'ms'
                this.setTransform(this.index * -1 * this._width)
                this.t.m = 0
                this.t.s = -1 //保证下次重新赋值
                if (this.autoPlay) {
                    this.setTime()
                }
                var timeDuration = type == 'touch' ? '250' : this.duration
                setTimeout(() => {
                    this.dom.transition = '0s'
                    this.dom3.transition = '0s'
                    if (this.index >= this.slidesLength + 1) {
                        this.index = 1
                        this.setTransform(this.index * -1 * this._width)
                    }
                    if (this.index <= 0) {
                        this.index = this.slidesLength
                        this.setTransform(this.index * -1 * this._width)
                    }
                    this.$emit('transtionend', this.index - 1)
                    this.auto = true
                    this.slideing = true
                  
                     for(var i=0;i<this.imgLen;i++){
                        this.dom2[i].style.transform='scale(1)'
                        this.dom2[i].style.transition='250ms'
                    } 
                }, timeDuration)
            },
            setTime() {
                this.timer1 = window.setTimeout(() => {
                    if (this.auto) {
                        this.index++
                        this.wh()      
                    }
                    else {
                        window.clearTimeout(this.timer1)
                    }
                }, this.interval)
            },
            starDom() {
                var SlideDom = document.querySelector('.' + this.className).getElementsByClassName('bgImg')
                var SlideDom2 = document.querySelector('.bg-img').getElementsByClassName('wh_bg')
                this.slidesLength = SlideDom.length
                this.slidesLength2 = SlideDom2.length
                var cloneDom1 = SlideDom[0].cloneNode(true) //向最后append
                var cloneDom2 = SlideDom[this.slidesLength - 1].cloneNode(true) //向最前append
                var clonebg1 = SlideDom2[0].cloneNode(true)
                var clonebg2 = SlideDom2[this.slidesLength2 -1].cloneNode(true)
                document.querySelector('.' + this.className).insertBefore(cloneDom2, SlideDom[0])
                document.querySelector('.' + this.className).appendChild(cloneDom1)
                document.querySelector('.bg-img').insertBefore(clonebg2,SlideDom2[0])
                document.querySelector('.bg-img').appendChild(clonebg1)
                this.dom3 = document.querySelector('.bg-img').style
                this._width = document.documentElement.clientWidth
                this.dom = document.querySelector('.' + this.className).style
                this.dom2 = document.querySelectorAll('.' + this.className + ' .bgImg img')
                 
            },
            clearTimeOut() {
                this.auto = false
                window.clearTimeout(this.timer1)
            }
        }
    }
</script>

<style>
    .bannerCom .wh_content {
        position: relative;
        z-index: 1;
        width: 100%;
    }
    .bannerCom .wh_swiper {
        display: -webkit-box;
        display: -moz-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -moz-transition-duration: 0s linear;
        -webkit-transition-duration: 0s linear;
        -o-transition-duration: 0s linear;
        transition-duration: 0s linear;
    }
    .bannerCom .wh_indicator {
        position: absolute;
        bottom: 10px;
        width: 100%;
        text-align: center;
        background: 0 0;
    }
    .bannerCom .wh_indicator_item {
        display: inline-block;
        width: 6px;
        height: 6px;
        margin: 1px 2px;
        cursor: pointer;
        border-radius: 100%;
        background: #666;
        border:1px solid #666;
    }
    .bannerCom .wh_show_bgcolor {
        background: white;
    }
    .bannerCom .bg-img{
        position:absolute;
        z-index:-1;
    }
    .bannerCom .bg-img .wh_bg{
        width: 100vw;
        height: 100%;
        float:left;
    }
    .bannerCom .bg-img .wh_bg img{
        width: 100%;
        height: 100%;
    }
    .bannerCom .wh_swiper .bgImg{
    width: 100vw;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .bannerCom .wh_content img {
    width: 95%;
    position: absolute;
    z-index: 445445;
    float: left;
    bottom: 0;
    border-radius: 10px;
    object-fit: cover;
  }
</style>


// WEBPACK FOOTER //
// src/components/sqswiper/sqswiper.vue